import "../application.scss"
// import "bootstrap" 
import "@hotwired/turbo-rails"
import "../../javascript/controllers"

// For direct_uploads
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
